$(function () {
    var filter_info_button = $('.filterInfoButton');
    var filter_info = $('.filterInfo');
    var filter_info_text = $('.filterInfo').find('span');

    filter_info_button.attr('aria-expanded', 'false');

    filter_info_button.click(function (event) {
        event.preventDefault();

        if ($(this).hasClass('__active')) {
            filter_info.slideUp().css('opacity', '0');
            $(this).attr('aria-expanded', 'false').removeClass('__active');
            filter_info_text.html('Show filter info');
        }
        else {
            filter_info.slideDown().css('opacity', '1');
            $(this).attr('aria-expanded', 'true').addClass('__active');
            filter_info_text.html('Hide filter info');
        }
    });
});